

import React, { useEffect} from "react";

import { StarFill, ExclamationTriangle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function SessionHeader({column}){

    const { t } = useTranslation();

    useEffect(()=>{
       // console.log("SessionHeader effect");

        return (()=>{
            //console.log("SessionHeader effect done");
        });
    }, []);

    switch(column.name){
      case "problem":{
        return (
            <ExclamationTriangle
              size="16"
              className="problem problemed"
            ></ExclamationTriangle>          
        )
      }
      case "bookmark":{
        return <StarFill
        size="16"
        className="bookmark bookmarked"
      ></StarFill>
    }
    default:{
      return t("app.session.columns." + column.name + ".name");
    }
  }
}
export default SessionHeader;